import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Details } from '@shared/modules/details';
import { ScopingActions } from '@store/actions';
import { ScopingSelectors } from '@store/selectors';

export const ScopingDetails: FC<RouteComponentProps> = (
  props: PropsWithChildren<RouteComponentProps>,
) => {
  const dispatch = useDispatch();
  const scopingSiteInfo = useSelector(ScopingSelectors.getScopingSiteInfo);

  useEffect(
    () => (): void => {
      dispatch(ScopingActions.resetTabsData.done(undefined));
    },
    [],
  );

  return <Details {...props} fuzeID site={scopingSiteInfo} />;
};
